import React from 'react';
import {Loading} from 'Components/Partials';

import Unauthenticated from 'Components/Layouts/Unauthenticated';

import {translation} from 'Services/TranslationHelpers';

import AddToCalendar from './AddToCalendar';

export default class AddToCalendarPage extends React.Component {
    /**
     * @var state
     */
    state = {
        loading: true,
        item: this.props.match?.params?.item ?? null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = async () => {
        this.setState({loading: false});
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {loading, item} = this.state;

        if (item === "1") {
            var event = {
                title: 'Example',
                description: '',
                location: process.env.MIX_APP_URL,
                startTime: '2021-04-26T12:00:00.000000Z',
                endTime: '2021-04-26T13:00:00.000000Z',
                timezone: 'UTC'
            };

            var filename = 'Example';
        }

        return (
            <Unauthenticated>
                <h2 className="text-lg text-center font-medium text-gray-900 mb-6">
                    {translation('agenda', 'add_to_calendar')}
                </h2>

                {loading && <Loading />}

                {!loading && !event &&
                    <p className="text-center">
                        {translation('misc', 'invalid_link')}
                    </p>
                }

                {!loading && event &&
                    <AddToCalendar event={event} filename={filename} />
                }
            </Unauthenticated>
        )
    }
};